<span *ngIf="value; else emptyValue">{{value | address}}</span>
<ng-template #emptyValue>
  <span *ngIf="emptyValueDisplay">{{ emptyValueDisplay }}</span>
</ng-template>
